import React from 'react';

export default function HackingSectionHeaders4() {
    return (
        <React.Fragment>
            <>
                <section className>
  <div className="container px-4 mx-auto">
    <div className="relative md:pt-16 lg:mt-32">
      <div className="max-w-2xl mb-16 mx-auto text-center">
        <h2 className="mb-8 text-4xl lg:text-5xl font-bold font-heading">一次非公式化创业的实验</h2>
      </div>
      <div className="relative max-w-3xl mx-auto">
        <img className="top-0 left-0 mx-auto w-full rounded-xl object-cover" src="https://static.shuffle.dev/uploads/files/9d/9d10ed0533a2f5a309eabf70e599971ed8a7e37a/Calls2.png" alt />
      </div>
    </div>
  </div>
  <div className="hidden navbar-menu fixed top-0 left-0 bottom-0 w-5/6 max-w-sm z-50">
    <div className="navbar-backdrop fixed inset-0 bg-gray-800 opacity-25" />
    <nav className="relative flex flex-col py-6 px-6 w-full h-full bg-white border-r overflow-y-auto">
      <div className="flex items-center mb-8">
        <a className="mr-auto text-2xl font-semibold leading-none" href="#">
          <img className="h-8" src="mockup-assets/logos/shuffle-ux.svg" alt width="auto" />
        </a>
        <button className="navbar-close">
          <svg className="h-6 w-6 text-gray-400 cursor-pointer hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div>
        <ul>
          <li className="mb-1"><a className="block p-4 text-sm font-semibold text-gray-900 hover:bg-gray-50 rounded" href="#">About</a></li>
          <li className="mb-1"><a className="block p-4 text-sm font-semibold text-gray-900 hover:bg-gray-50 rounded" href="#">Company</a></li>
          <li className="mb-1"><a className="block p-4 text-sm font-semibold text-gray-900 hover:bg-gray-50 rounded" href="#">Services</a></li>
          <li className="mb-1"><a className="block p-4 text-sm font-semibold text-gray-900 hover:bg-gray-50 rounded" href="#">Testimonials</a></li>
        </ul>
      </div>
      <div className="mt-auto">
        <p className="mt-6 mb-4 text-sm text-center text-gray-400">
          <span>© 2021 All rights reserved.</span>
        </p>
      </div>
    </nav>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

